import React, { useEffect, useRef, useState } from 'react';
import { default as __ } from '../../../utils';
import { colors } from '../../../styles';
import Avatar from '../../../components/padel/avatar';
import Shape from '../../../components/utils/shape';
import Pinned from '../../../components/utils/pinned';


function timestampToDay(date) {
  var dat = new Date(date);
  const day = ('0' + dat.getDate()).substr(-2);
  const month = ('0' + (dat.getMonth() + 1)).substr(-2);
  return [day, month];
}

function Item(props) {
  let theme = props.mvp ? colors.highlight : colors.accent_alpha;
  let player = props.players.find(p => p.you);
  let posPlayer = __.unwrapIterable(player).position;

  let result = props.victory ? (
    <Shape.Triangle
      fill={colors.accent_alpha}
      size={120}
      transform={'translateY(25px)'}
    />
  ) : (
    <Shape.Triangle
      fill={colors.accent_alpha}
      size={120}
      transform={'rotate(180deg)'}
    />
  );
  let [day, month] = timestampToDay(new Date(props.updated.seconds * 1000));

  return (
    <li archive-item="" className="col-between align-center">
      <div
        className="row-between align-center flex-stretch"
        style={{
          padding: posPlayer === 'left' ? '10px 28px 0 0' : '10px 0 0 28px ',
          flexDirection: posPlayer === 'left' ? 'row' : 'row-reverse',
        }}
      >
        <Avatar.Small shade={colors.accent_alpha} />
        <Shape.Penta fill={theme} size={50} />
      </div>

      <Pinned
        isCenteredX
        offsetY={props.victory ? '14px' : '30px'}
        elevation={2}
      >
        {result}
      </Pinned>

      <Pinned elevation={4}>
        <p className="txt-l -accent">{day}</p>
      </Pinned>
    </li>
  );
}

function ActionBar({ children, fixed, isRowBetween = false }) {
  let styles = fixed
    ? {
        transform: 'scale(.64)',
        padding: '8px',
        transformOrigin: 'left',
      }
    : {};

  if (isRowBetween)
    return (
      <div className="pill-button pill-button-no-height row-between align-center">
        {children}
      </div>
    );

  return (
    <div
      style={styles}
      className="pill-button pill-button-no-height row-start align-center"
    >
      {children}
    </div>
  );
}

function Pagination({ cb, month, max }) {
  return (
    <ActionBar isRowBetween>
      {month - 1 > 0 && (
        <div onClick={() => cb(month - 1)}>
          <Shape.Triangle
            size={50}
            fill={colors.accent}
            transform={'rotate(-90deg) translateX(-10px)'}
          />
          <p>{month - 1}</p>
        </div>
      )}
      {month + 1 <= max && (
        <div onClick={() => cb(month + 1)}>
          <Shape.Triangle
            size={50}
            fill={colors.accent}
            transform={'rotate(90deg) translateX(10px)'}
          />
          <p>{month + 1}</p>
        </div>
      )}
    </ActionBar>
  );
}

function NoResults({ m }) {
  return (
  <p className="txt-xl -accent txt-center">0 resultados para mes {m}</p>
  );
}

export default Item;
export { ActionBar, NoResults, Pagination };
